import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Switch, Select } from '@mui/material';

// ============================================
// 입장시간 설정 모달 styled-components
// Figma: 입장시간 설정_모달 (node 3758:4714)
// ============================================

// ============================================
// Layout
// ============================================
export const ModalBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
});

// 입력 비활성(매장 영업시간과 동일 ON) 시 본문을 잠그는 래퍼
export const LockableSection = styled(Box, {
  shouldForwardProp: prop => prop !== 'locked',
})(({ locked }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  ...(locked && {
    opacity: 0.5,
    pointerEvents: 'none',
  }),
}));

// ============================================
// 매장 영업시간과 동일 배너
// ============================================
export const SameAsStoreBanner = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  padding: '12px 20px',
  borderRadius: '8px',
  backgroundColor: '#EAF6F7',
});

export const BannerTextRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const BannerTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#0F7F85',
});

export const BannerHint = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  color: '#dc2626',
});

// ============================================
// 요일별 영업시간 행
// ============================================
export const DayRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const DayLabel = styled(Typography)({
  width: '50px',
  fontSize: '14px',
  fontWeight: 500,
  color: '#000',
});

export const OpenToggleWrap = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  width: '100px',
});

export const OpenToggleText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isOpen',
})(({ isOpen }) => ({
  fontSize: '13px',
  color: isOpen ? '#4AB3BC' : '#888',
}));

export const TealSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#4AB3BC',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#4AB3BC',
  },
});

export const TimeSelect = styled(Select, {
  shouldForwardProp: prop => prop !== 'isOpen',
})(({ isOpen }) => ({
  width: '80px',
  backgroundColor: isOpen ? '#fff' : '#f5f5f5',
}));

export const Colon = styled(Typography)({
  color: '#888',
});

export const Tilde = styled(Typography)({
  color: '#888',
});

export const ApplyLabelText = styled('span')({
  fontSize: '13px',
});

// 종료가 시작보다 같거나 빠를 때(자정 넘김) 종료 시간 옆에 표시하는 "익일" 배지 — IoT 주간 스케줄과 동일 스타일
export const NextDayBadge = styled('span')({
  flexShrink: 0,
  padding: '1px 6px',
  borderRadius: '4px',
  background: '#FFF3E0',
  color: '#E8833A',
  fontSize: '11px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
});

// ============================================
// 휴무일 아코디언
// ============================================
export const HolidaySection = styled(Box)({
  marginTop: '10px',
});

export const AccordionHeader = styled(Box, {
  shouldForwardProp: prop => prop !== 'expanded',
})(({ expanded }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 20px',
  border: '1px solid #ddd',
  borderRadius: expanded ? '8px 8px 0 0' : '8px',
  cursor: 'pointer',
  backgroundColor: '#fff',
  '&:hover': { backgroundColor: '#fafafa' },
}));

export const AccordionTitle = styled(Typography)({
  fontWeight: 500,
  fontSize: '14px',
  color: '#000',
});

export const AccordionContent = styled(Box)({
  display: 'flex',
  border: '1px solid #ddd',
  borderTop: 'none',
  borderRadius: '0 0 8px 8px',
  minHeight: '300px',
});

// 왼쪽: 선택된 휴무일 목록
export const HolidayListPane = styled(Box)({
  flex: 1,
  padding: '16px',
  borderRight: '1px solid #ddd',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

export const AddHolidayButton = styled(Button)({
  color: '#0F7F85',
  borderColor: '#0F7F85',
  fontSize: '13px',
  '&:hover': {
    borderColor: '#0F7F85',
    backgroundColor: 'rgba(15, 127, 133, 0.04)',
  },
});

export const HolidayChips = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'flex-start',
  gap: '8px',
});

export const HolidayChip = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 12px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  backgroundColor: '#fff',
  height: 'fit-content',
});

export const HolidayChipText = styled(Typography)({
  fontSize: '13px',
  color: '#333',
});

export const HolidayChipRemove = styled('span')({
  cursor: 'pointer',
  color: '#999',
  fontSize: '16px',
  lineHeight: 1,
  '&:hover': { color: '#666' },
});

// 오른쪽: 달력
export const CalendarPane = styled(Box)({
  width: '280px',
  padding: '16px',
});

export const CalendarHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
});

export const CalendarNavArrow = styled(Box)({
  cursor: 'pointer',
  color: '#0F7F85',
  fontSize: '18px',
  fontWeight: 'bold',
  padding: '0 8px',
  '&:hover': { opacity: 0.7 },
});

export const CalendarMonthLabel = styled(Typography)({
  fontWeight: 500,
  fontSize: '16px',
});

export const WeekDayHeaderRow = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  textAlign: 'center',
  marginBottom: '8px',
});

export const WeekDayHeaderCell = styled(Typography, {
  shouldForwardProp: prop => prop !== 'dayIndex',
})(({ dayIndex }) => ({
  fontSize: '12px',
  fontWeight: 500,
  color: dayIndex === 0 ? '#E57373' : dayIndex === 6 ? '#64B5F6' : '#666',
  padding: '4px 0',
}));

export const CalendarGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: '2px',
});

export const CalendarDayCell = styled(Box, {
  shouldForwardProp: prop => !['isSelected', 'isCurrentMonth', 'isSunday', 'isSaturday'].includes(prop),
})(({ isSelected, isCurrentMonth, isSunday, isSaturday }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '32px',
  cursor: 'pointer',
  borderRadius: '4px',
  fontSize: '13px',
  backgroundColor: isSelected ? '#333' : 'transparent',
  color: isSelected
    ? '#fff'
    : !isCurrentMonth
      ? '#ccc'
      : isSunday
        ? '#E57373'
        : isSaturday
          ? '#64B5F6'
          : '#333',
  '&:hover': {
    backgroundColor: isSelected ? '#333' : '#f0f0f0',
  },
}));
